/// <reference path="../../../common/common/common.ts" />
/// <reference path="../../../../teva/selectbox/selectbox.ts" />

namespace OfficeGuy.Inputs {
    export class BankPicker {
        static InitEditors(Container = null) {
            Teva.SelectBox.Enable($("input.bankpicker", Container), {
                QueryMethod: function (Query, QueryByID, PageIndex, Callback) {
                    Common.AjaxRequest({
                        Method: 'GET',
                        URL: "/bankpicker/",
                        SuccessMethod: function (Response) {
                            var data = {
                                results: [],
                                more: false
                            };
                            for (var i = 0; i < Response.length; i++) {
                                data.results.push({
                                    id: Response[i].id,
                                    text: Response[i].id + " - " + Response[i].text
                                });
                            }
                            data.results = Teva.SelectBox.FilterResults(data.results, Query, QueryByID);
                            Callback(data, Query);
                        },
                        ShowLoading: false
                    });
                },
                AllowManualValues: true,
                SelectFirstOnClose: true
            });
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Inputs.BankPicker.InitEditors(Container);
});